import GetBannerForm from './GetBannerForm';

export default GetBannerForm;
